import {
  InlineButton,
  ControlSizesMD,
} from '@picsart/design-system/components/InlineButton';
import { IconChevronLeft } from '@picsart/design-system/foundation/icons/IconChevronLeft';

import useStyles from './styles';
import { SettingsPanelVariant } from './types';

interface SettingsHeaderProps {
  variant: SettingsPanelVariant;
  onBack?: () => void;
}

const SettingsHeader = ({ variant, onBack }: SettingsHeaderProps) => {
  const classes = useStyles();
  const isPage = variant === SettingsPanelVariant.Page;

  if (isPage && onBack) {
    return (
      <div className={classes.pageHeader}>
        <InlineButton
          dataTestId="genai-settings-back"
          size={ControlSizesMD}
          centerIcon={IconChevronLeft}
          onClick={onBack}
          aria-label="Back"
          isWithoutBorder
          isWithoutBackground
        />
        <span className={classes.pageTitle}>Settings</span>
      </div>
    );
  }

  if (!isPage) {
    return (
      <div className={classes.dropdownHeader}>
        <span className={classes.pageTitle}>Settings</span>
      </div>
    );
  }

  return null;
};

export default SettingsHeader;
